import React, { useEffect, useState, useRef } from 'react';
import {  ScrollView,  View,  Text,  TouchableOpacity, DimensionValue } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { Tooltip } from 'react-native-paper';

import { TextMediumSize } from '../../common/constants/Fonts';

import { equipmentsTableStyle } from './styles/EquipmentsTableStyle';

interface Props {
  items: any;
  onEdit?: (item, index) => void;
  onDelete?: (item, index) => void;
  onPenalty?: (item, index) => void;
  width?: DimensionValue;
  isExtra? : boolean;
  extraWith? : number;
}

const EquipmentsTable =  ({ items, onEdit, onDelete, onPenalty, width, isExtra, extraWith }: Props) => {
  
  const [tableData, setTableData] = useState([]);

  useEffect(()=>{
    if(items && items.length && items.length > 0){
      if(typeof(items) == 'string')
      items = JSON.parse(items);
      setTableData(items);
    }else{
      setTableData([]);
    }
  }, [items])

  const renderTableData = () => {
    const rows = [];
    if (tableData.length > 0) {
      tableData.map((item, index) => {
        rows.push(
          <View key={index} style={styles.tableRow}>
            <View style={[styles.cell, {width:50, alignItems:'flex-end'}]}>
              <Text>{(index + 1)}</Text>
            </View>
            <View style={[styles.cell, {flex:1}]}>
              <Text>{item.display_name}</Text>
            </View>
            {/* <View style={[styles.cell, { width: 100, paddingRight: 6, alignItems: 'flex-end' }]}>
              <Text>{item.quantity ? item.quantity : '0'}</Text>
            </View> */}
            <View style={[styles.cell, { width: 100, paddingRight: 6, alignItems: 'flex-end' }]}>
              <Text>{(item.price ? item.price : 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</Text>
            </View>
            {isExtra && (
              <View style={[styles.cell, { width: extraWith || 400, flexDirection:'row', flexWrap:'wrap', alignItems:'center', justifyContent:'flex-start', paddingVertical:2, paddingHorizontal:6}]}>
              {item && item.extras && item.extras.map((extra, index) => (
                <Tooltip key={index} title={extra.name} enterTouchDelay={100} leaveTouchDelay={100}>
                  <View style={{borderWidth:1, borderColor:'#ccc', margin:4, paddingTop: 1, paddingBottom:4, paddingHorizontal:8, borderRadius:10, maxWidth:110, backgroundColor:'#6B3FA0'}}>
                    <Text numberOfLines={1} ellipsizeMode="tail" style={{color:'white'}}>
                      {extra.name}
                    </Text>
                  </View>
                </Tooltip>
              ))}
              </View>
            )}
            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  if(onPenalty) onPenalty(item, index);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="gavel" color="black" />
              </TouchableOpacity>
            </View>
            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  if(onEdit) onEdit(item, index);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </View>
            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  if(onDelete) onDelete(item, index);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="times" color="black" />
              </TouchableOpacity>
            </View>
          </View>
        );
      });
    } else {
      <></>;
    }
    return <>{rows}</>;
  };

  return (
    <View style={styles.container}>
      <View style={[styles.tableContainer, {width:width || 740}]}>
        <View style={[styles.tableHeader]}>
          <Text style={[styles.columnHeader, { width: 50 }]}>{'No'}</Text>
          <Text style={[styles.columnHeader, { flex:1 }]}>{'Product Family'}</Text>
          {/* <Text style={[styles.columnHeader, { width: 90 }]}>{'Quantity'}</Text> */}
          <Text style={[styles.columnHeader, { width: 75 }]}>{'Price'}</Text>
          {isExtra && (
            <Text style={[styles.columnHeader, { width: extraWith || 400 }]}>{'Extras'}</Text>
          )}
          <Text style={[styles.columnHeader, styles.IconCell]}>{'Penalty'}</Text>
          <Text style={[styles.columnHeader, styles.IconCell]}>{'Edit'}</Text>
          <Text style={[styles.columnHeader, styles.IconCell]}>{'DEL'}</Text>
        </View>
        <ScrollView
          style={{ minHeight:200}}>
          {renderTableData()}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = equipmentsTableStyle;

export default EquipmentsTable;
